import graphql from "../../graphql";

export default {
  namespaced: true,
  getters: {
    parkingSpaces: state => state.parkingSpaces,
    parkingSpacesDistance: state => distancePoint =>
      state.parkingSpaces
        .map(space => ({ ...space, distance: getDistance(space, distancePoint) }))
        .sort((space1, space2) => space1.distance - space2.distance),
  },
  actions: {
    fetchParkingSpaces: ({ commit }, { cityZoneId }) => {
      graphql.query({ query: parkingSpacesQuery, variables: { cityZoneId } }).then(response => {
        if (response.data) {
          commit("setParkingSpaces", response.data.parkingSpaces.nodes);
        } else {
          commit(
            "flashMessages/setMessages",
            response.errors.map(error => ["error", error.message]),
            { root: true }
          );
        }
      });
    },
  },
  mutations: {
    setParkingSpaces: (state, parkingSpaces) => (state.parkingSpaces = parkingSpaces),
  },
  state: {
    parkingSpaces: [],
  },
};

window.graphql = graphql;

const parkingSpacesQuery = `
query($cityZoneId: ID!) {
  parkingSpaces(cityZoneId: $cityZoneId) {
    nodes {
      name
      lat
      lng
      occupancy
      capacity
      updatedAt
    }
  }
}
`;

const getDistance = (p1, p2) => {
  // taken from https://www.movable-type.co.uk/scripts/latlong.html
  const R = 6371e3;
  const φ1 = (p1.lat * Math.PI) / 180;
  const φ2 = (p2.lat * Math.PI) / 180;
  const Δφ = ((p2.lat - p1.lat) * Math.PI) / 180;
  const Δλ = ((p2.lng - p1.lng) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Math.round(R * c);
};
